module.exports = function() {
  return new Worker(__webpack_public_path__ + "89898ae5bf3c56a06612.worker.js");
};